export default "__VITE_ASSET__Ca_m_2QU__"